import {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    object,
    moreNav,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
} from './ThirdMapping';

import { setDatabotsNavMap } from 'js/vue/helpers';

const databots = {
    activity: 'client-overview__menu--activity',
    informations: 'client-overview__menu--general-info',
    financialactivity: 'client-overview__menu--financial-info',
    contacts: 'client-overview__menu--contact-linked',
    addresses: 'client-overview__menu--address',
    customfields: 'client-overview__menu--cf',
    statistics: 'client-overview__menu--stat',
    opportunity: 'client-overview__menu--opportunity',
    estimate: 'client-overview__menu--document',
    invoice: 'client-overview__menu--document',
    delivery: 'client-overview__menu--document',
    order: 'client-overview__menu--document',
    creditnote: 'client-overview__menu--document',
    proforma: 'client-overview__menu--document',
    payments: 'client-overview__menu--payment',
    bankaccount: 'client-overview__menu--bank-account',
    recurring: 'client-overview__menu--recurring',
    mandates: 'client-overview__menu--mandate',
    timetracking: 'client-overview__menu--timetracking',
    tickets: 'client-overview__menu--ticket',
    project: 'client-overview__menu--project',
    proposal: 'client-overview__menu--proposal',
    emailingprofile: 'client-overview__menu--mailing-list',
    massmailingMailinglist: 'client-overview__menu--mailing-list',
    massmailingCampaignList: 'client-overview__menu--mailing-list',
    receipts: 'client-overview__menu--receipt',
    briefcase: 'client-overview__menu--briefcase',
    activitycommentadd: 'client-overview__activity--comment-add',
    emailadd: 'client-overview__activity--email-add',
    calladd: 'client-overview__activity--call-add',
    scheduledcalladd: 'client-overview__activity--scheduled-call-add',
    taskadd: 'client-overview__activity--task-add',
    eventadd: 'client-overview__activity--event-add',
    generalinfoedit1: 'client-overview__section--general-info-edit-1',
    generalinfoedit2: 'client-overview__section--general-info-edit-2',
    marketing: 'client-overview__section--marketing',
};

setDatabotsNavMap(navMap, databots);

var entitiesGroups = [
    {
        label: Loc.g('Activité'),
        value: 'clientActivity',
        entities: [
            'task',
            'event',
            'annotation',
            'email',
            'phonecall',
            'client',
            'timetracking',
            'ticket',
            'snippettracking',
            'marketing',
        ],
    },
    {
        label: Loc.g('Prospection'),
        value: 'prospection',
        entities: ['campaign', 'opportunity', 'estimate', 'propdocument'],
    },
    {
        type: 'component',
        component: 'timeline-author-filter',
        label: Loc.g('Collaborateurs'),
        value: 'authors',
        filter: true,
        entities: [],
        display: 'block',
    },
];

var entitiesTabs = [
    {
        label: Loc.g('Activité'),
        value: 'activity',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Éléments épinglés'),
        value: 'pinned',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Commentaires'),
        value: 'note',
        entities: ['annotation'],
        databot: 'client-overview__activity--comment-list',
    },
    {
        label: Loc.g('Emails'),
        value: 'email',
        entities: ['email'],
        databot: 'client-overview__activity--email-list',
    },
    {
        label: Loc.g('Tâches'),
        value: 'task',
        entities: ['task'],
        databot: 'client-overview__activity--task-list',
    },
    {
        label: Loc.g('Evènements'),
        value: 'event',
        entities: ['event'],
        databot: 'client-overview__activity--event-list',
    },
    {
        label: Loc.g('Appels'),
        value: 'phonecall',
        entities: ['phonecall'],
        databot: 'client-overview__activity--call-list',
    },
    {
        label: Loc.g('Marketing'),
        value: 'marketing',
        entities: ['marketing'],
        databot: 'client-overview__activity--marketing-list',
    },
];

var defaultEntities = [
    'email',
    'phonecall',
    'client',
    'annotation',
    'event',
    'task',
    'timetracking',
    'ticket',
    'campaign',
    'opportunity',
    'estimate',
    'propdocument',
    'snippettracking',
    'marketing',
];

var forcedLabel = [
    {
        value: 'client',
        label: Loc.g('Mises à jour'),
    },
];

headerActions.push({
    label: Loc.g("Télécharger l'état du compte"),
    type: 'js',
    value: "javascript:Third.getConsolidatedTrade({id}, 'client')",
    permission: true,
});

var availableStatCards = [
    'invoice_third',
    'estimate_third',
    'turnover_third',
    'top_selling_items_third',
    'sales_margin_third',
];

export {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    entitiesGroups,
    entitiesTabs,
    defaultEntities,
    forcedLabel,
    object,
    moreNav,
    availableStatCards,
    databots,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
};
